import React from 'react';
import { variants } from '../../../variants/variants';
import { getHHMM } from '../../../utils/dateTimeFormats';
import VerifiedIcon from '@mui/icons-material/Verified';
import NewReleasesIcon from '@mui/icons-material/NewReleases';

const DetailsCard = ({ user, highlightIndex, id, selectedFloor = 0 }) => {
  
  let currentLocation = localStorage.getItem('location');
  const itemArray = currentLocation == 'Ahmedabad' ? ['morningTea', 'eveningTea', 'snack', 'healthy'] : ['morningTea', 'eveningTea', 'snack'];
  function renderKeyValue(user, key) {
    // const slicedKey = key.slice(2);
    const text = currentLocation == 'Ahmedabad'? { morningTea: 'Morning', eveningTea: 'Evening', snack: 'Snack', healthy: 'Healthy' } : { morningTea: 'Morning', eveningTea: 'Evening', snack: 'Snack' };
    const value = (user.count ? user?.count?.[key] : user[key] ? 1 : 0) || 0;
    return  text[key] && `${text[key]} (${value})`;
  }

  

  return (
    <div
      className="card m-2"
      style={{
        transition: 'background-color 2s ease',
        backgroundColor: id !== highlightIndex ? 'transparent' : '#96eb9a',
        padding: '5px',
        border: '1px solid #ccc',
        borderRadius: variants.boxRadius.MAIN,
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px', fontWeight: 'bold' }}>
          <div>{user.name}</div>
          <div className="text-secondary">
            {currentLocation == 'Ahmedabad' && selectedFloor === 0 && ['Terrace', 'Ground'][user.floor - 1] + ' - '}
            {user.modified ? getHHMM(user.modified) : getHHMM(new Date())}
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
          {itemArray.map((key, index) => (
            <div
              key={index}
              style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}
            >
              {user.count[key] > 0 ? <VerifiedIcon color="success" /> : <NewReleasesIcon color="disabled" />}
              <p style={{ fontSize: '15px', margin: '0px' }}>{renderKeyValue(user, key)}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DetailsCard;
